import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';

import { getEvent } from '../../../ducks/event';
import Connect from './Connect';
import Done from './Done';
import Events from './Events';
import Flash from '../components/Flash';
import Gift from './Gift';
import Help from './components/Help';
import LanguageSelect from '../components/LanguageSelect';
import Loader from '../components/Loader';
import Manage from './Manage';
import Map from './Map';
import Referral from './Referral';
import TicketsList from './Tickets';
import styles from './seatmap.scss';

const DESCRIPTION = 'Your DreamHack tickets – see your tickets, give tickets away, choose seats, and overall management of your DreamHack tickets.';
const AVAILABLE_LANGUAGES = ['en', 'sv', 'fr', 'es'];

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string,
    }),
  }),
  seatmapError: PropTypes.shape({
    message: PropTypes.string,
  }),
  eventError: PropTypes.shape({
    message: PropTypes.string,
  }),
  event: PropTypes.shape({
    id: PropTypes.string,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  loading: PropTypes.bool,
};

const messages = defineMessages({
  flashErrorTitle: {
    id: 'seatmap.flash.title.default',
    defaultMessage: 'We encountered an error',
  },
  brokenLinkMessage: {
    id: 'seatmap.notfound.message.default',
    defaultMessage: 'Seems like the link you got is broken. The only advice I can get you is to ether go back to the source where you got the link or contact our support team below.',
  },
});

class Seatmap extends React.Component {
  componentDidMount() {
    const {
      dispatch,
      match: { params: { eventId } },
    } = this.props;
    if (eventId) {
      dispatch(getEvent(eventId));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      dispatch,
      match: { params: { eventId } },
    } = this.props;

    const { match: { params: { eventId: newEventId } } } = newProps;

    if (newEventId && newEventId !== eventId) {
      dispatch(getEvent(newEventId));
    }
  }

  render() {
    const {
      eventError,
      seatmapError,
      history,
      loading,
      event,
    } = this.props;
    const { formatMessage } = this.props.intl;
    const error = (eventError && eventError.message) || (seatmapError && seatmapError.message);

    return (
      <div className={styles.seatmap}>
        <Helmet>
          <meta name="viewport" content="viewport-fit=cover, initial-scale=1, maximum-scale=1, user-scalable=no, width=device-width" />
          <meta name="format-detection" content="telephone=no" />
          <title>DreamHack · Tickets</title>
          <meta property="og:description" content={DESCRIPTION} />
          <meta name="description" content={DESCRIPTION} />
        </Helmet>
        <div className={styles.header}>
          <div
            className={styles.icon}
            role="button"
            tabIndex={0}
            onClick={() => history.goBack()}
          >
            <i className="far fa-chevron-left" />
          </div>
          <div className={styles.controls}>
            <Help />
            <span className={styles.middot}>
              &middot;
            </span>
            <LanguageSelect availableLanguages={AVAILABLE_LANGUAGES} />
          </div>
        </div>
        <Loader loading={loading} />
        <Flash
          title={formatMessage(messages.flashErrorTitle)}
          message={error}
          error
        />
        <div className={styles.content}>
          { event
            && (
            <Switch>
              <Route exact path="/tickets/:eventId/:orderId/connect" component={Connect} />
              <Route exact path="/tickets/:eventId/referral/:referralId" component={Referral} />
              <Route exact path="/tickets/:eventId/seatmap" component={Map} />
              <Route exact path="/tickets/:eventId/list/:type" component={TicketsList} />
              <Route exact path="/tickets/:eventId/gift/:ticketId" component={Gift} />
              <Route exact path="/tickets/:eventId/gift/:ticketId/done" component={Done} />
              <Route exact path="/tickets/:eventId/place/:ticketId" component={Map} />
              <Route exact path="/tickets/:eventId/place/:ticketId/done" component={Done} />
              <Route exact path="/tickets/:eventId/manage" component={Manage} />
              <Redirect exact from="/tickets/:eventId" to="/tickets/:eventId/manage" />
            </Switch>
            )}
          { !event && eventError && (
            <>
              <h1>Ooops!</h1>

              <div style={{ fontSize: 14 }}>{formatMessage(messages.brokenLinkMessage)}</div>
            </>
          )}
          <Switch>
            <Route exact path="/tickets" component={Events} />
          </Switch>
          <div className={styles.help}>
            <Help />
            <span className={styles.middot}>
              &middot;
            </span>
            <LanguageSelect availableLanguages={AVAILABLE_LANGUAGES} />
          </div>
        </div>
      </div>
    );
  }
}

Seatmap.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    event: state.getIn(['event', 'data']),
    loading: state.getIn(['event', 'loading']),
    eventError: state.getIn(['event', 'error']),
    seatmapError: state.getIn(['seatmap', 'error']),
    tickets: state.getIn(['event', 'tickets']),
  };
}

export default injectIntl(connect(mapStateToProps)(Seatmap));
